import { createRouter } from '@tanstack/react-router';
import {
  DefaultErrorComponent,
  DefaultNotFoundComponent,
} from '@/common/ErrorScreen';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  // TODO: Is this how URLs are set up on the site? It seems like it on "https://worldbibleschool.org/login/?action=lostpassword" (slash before the '?')
  trailingSlash: 'always',
  // Without these, a route that throws unmounts its subtree and the page goes
  // blank. Set as router defaults so new routes inherit them.
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: DefaultNotFoundComponent,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
